import clsx from "clsx";
import { FC } from "react";

import { t } from "i18n/i18n";
import { ReactionVoteNoIcon, ReactionVoteYesIcon } from "mds/icons";
import { IconProps } from "mds/utils/images";
import { classUserSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

type VoteIndicatorProps = {
  classUserId: string;
  className?: string;
  iconSizeProps?: IconProps;
};

const VoteIndicator: FC<VoteIndicatorProps> = ({ classUserId, className, iconSizeProps }) => {
  const classUser = useObjectSelector(
    (state) => classUserSelectors.selectById(state, classUserId),
    ["vote"],
  );
  if (!classUser) return null;

  return (
    <div className={clsx("absolute", className)}>
      {classUser.vote === "yes" && (
        <ReactionVoteYesIcon aria-label={t("reactions.vote_yes")} {...iconSizeProps} />
      )}
      {classUser.vote === "no" && (
        <ReactionVoteNoIcon aria-label={t("reactions.vote_no")} {...iconSizeProps} />
      )}
    </div>
  );
};

export { VoteIndicator };
